import React from 'react'
import Link from 'gatsby-link'

const firstVisit = () => (
  <div>
    <h2>First Visit</h2>
    <h4>Before your treatment:</h4>
    <p>
      For your first treatment, please arrive 15-20 minutes early to fill out
      this <Link to="/patient-forms">paperwork</Link>, or have it with you when you
      arrive.
    </p>
    <p>
      Please arrive wearing comfortable clothes and having eaten within the last
      2-3 hours.
    </p>
    <h4>What to Expect:</h4>
    <p>
      Your first treatment will last between 75-90 minutes. We will take this
      time to discuss your case in depth and to answer any questions you have
      about acupuncture and Chinese medicine.
    </p>
    <p>Follow up visits usually last between 45-60 minutes.</p>
    <p>
      At your first visit, we will spend some time talking about the condition
      you would like to treat, as well as your health in general. I will ask
      questions to help me understand how best to treat your condition in the
      context of your overall health and lifestyle.
    </p>
    <p>
      At each session, I will do a physical assessment, which may include
      feeling your pulse, looking at your tongue, and feeling your abdomen or
      acupuncture points along your arms and legs. Based on our interview and
      these findings, I will make a Chinese medical diagnosis and individualized
      treatment plan.
    </p>
    <p>
      At each session, I will choose acupuncture points and techniques that are
      appropriate to you on that day. I use a wide variety of acupuncture
      techniques and will use the one that best fits your condition and level of
      comfort.
    </p>
    <p>
      In addition to acupuncture, I may also use other techniques, such as
      moxibustion (the burning of warming herbs near an acupuncture point), or
      cupping (creating a partial vacuum with glass or plastic cups as a way to
      relax tissues and stimulate blood flow), and the use of infra-red heat
      therapy.
    </p>
    <p>
      After your treatment, we will take a few moments to discuss the treatment
      plan, herbal medicine, and any exercises or lifestyle advice that may be
      important to your condition.
    </p>
    <h4>What do acupuncture needles feel like?</h4>
    <p>
      Acupuncture needles are fine, sterile, and used only once. Some people
      have no sensation at all when the needles are inserted, while others may
      feel a slight pinch, followed by a dull ache or tingling sensation, all
      normal sensations within an acupuncture treatment.
    </p>
    <h4>How long do the needles stay in?</h4>
    <p>
      Acupuncture needles are left in between 10 and 30 minutes. Many people
      find that during this time, they experience a deep sense of relaxation,
      and may even fall asleep.
    </p>
    <h4>How many treatments will you need?</h4>
    <p>
      The number of treatments required varies based on the individual and the
      condition. Some conditions may resolve in one session. A series of 5-10
      treatments is fairly common. Other conditions, particularly those that are
      degenerative or long-standing, may require several months of treatment or
      require on-going care.
    </p>
    <p>
      Conditions may require the use of herbal medicine, dietary modifications,
      exercises or lifestyle modifications. Incorporating these therapies will
      improve treatment efficacy and helps to shorten the treatment period.
      While conditions may not resolve immediately, signs that the treatment is
      helping should be apparent to both the patient and practitioner early on
      in the process.
    </p>
  </div>
)

export default firstVisit



// WEBPACK FOOTER //
// ./src/pages/first-visit.js